module.exports = __webpack_public_path__ + "static/media/human-advantage-pin.7a31fe2f.svg";